import {
  Sparkles, Eye, CalendarClock, Calendar, UserCheck, Play, AlertTriangle, Clock, CheckCircle2,
} from "lucide-react";

export const STATUS = {
  nueva: { label: "Nueva", cls: "bg-blue-500/10 text-blue-400 border-blue-500/20", icon: Sparkles },
  en_revision: { label: "En revisión", cls: "bg-purple-500/10 text-purple-400 border-purple-500/20", icon: Eye },
  pendiente_programacion: { label: "Pendiente de programación", cls: "bg-amber-500/10 text-amber-400 border-amber-500/20", icon: CalendarClock },
  programada: { label: "Programada", cls: "bg-indigo-500/10 text-indigo-400 border-indigo-500/20", icon: Calendar },
  asignada: { label: "Asignada", cls: "bg-cyan-500/10 text-cyan-400 border-cyan-500/20", icon: UserCheck },
  en_proceso: { label: "En proceso", cls: "bg-yellow-500/10 text-yellow-400 border-yellow-500/30", icon: Play },
  pendiente: { label: "Pendiente", cls: "bg-orange-500/10 text-orange-400 border-orange-500/30", icon: AlertTriangle },
  pendiente_cierre: { label: "Pendiente de cierre", cls: "bg-amber-500/20 text-amber-300 border-amber-500/40", icon: Clock },
  cerrada: { label: "Cerrada", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/30", icon: CheckCircle2 },
};

export const MANUAL_STATUSES = ["nueva", "en_revision", "pendiente_programacion", "programada", "asignada", "en_proceso", "pendiente"];

export const PRIORITY = {
  baja: { label: "Baja", cls: "text-slate-400" },
  media: { label: "Media", cls: "text-sky-400" },
  alta: { label: "Alta", cls: "text-orange-400" },
  urgente: { label: "Urgente", cls: "text-red-400" },
};

export const ROLE_LABEL = { admin: "Administrador", supervisor: "Supervisor / Operaciones", technician: "Técnico", finance: "Finanzas" };
